(function () {
  if (window.__simplerBlogTaggedSliderBound) return;
  window.__simplerBlogTaggedSliderBound = true;

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function esc(value) {
    return (value == null ? '' : String(value)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function withWidth(url, width) {
    if (!url) return '';
    if (!width) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function buildQuery(blogTitle, tag) {
    var parts = [];
    if (blogTitle) parts.push("blog_title:'" + blogTitle.replace(/(['\\])/g, '\\$1') + "'");
    if (tag) parts.push("tag:'" + tag.replace(/(['\\])/g, '\\$1') + "'");
    return parts.join(' AND ');
  }

  function getSectionRoots(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll('.simpler-blog-tagged-slider'));

    if (
      scope.classList &&
      scope.classList.contains('simpler-blog-tagged-slider') &&
      sections.indexOf(scope) === -1
    ) {
      sections.unshift(scope);
    }

    return sections;
  }

  function getConfig(container) {
    return {
      shop: container.getAttribute('data-sbtas-shop'),
      apiVersion: container.getAttribute('data-sbtas-api-version') || '2024-10',
      token: container.getAttribute('data-sbtas-token'),
      limit: parseInt(container.getAttribute('data-sbtas-limit'), 10) || 4,
      buttonLabel: container.getAttribute('data-sbtas-button-label') || 'Read More',
      imageWidth: parseInt(container.getAttribute('data-sbtas-image-width'), 10) || 800,
    };
  }

  var ARTICLES_QUERY =
    'query SbtasArticles($q: String!, $n: Int!) {' +
    '  articles(first: $n, sortKey: PUBLISHED_AT, reverse: true, query: $q) {' +
    '    edges { node { title handle onlineStoreUrl image { url altText } } }' +
    '  }' +
    '}';

  function hasArticleImage(node) {
    return !!(node && node.image && node.image.url);
  }

  function fetchArticles(config, blogTitle, tag, hideWithoutImage) {
    var fetchLimit = config.limit;
    if (hideWithoutImage) {
      fetchLimit = Math.min(Math.max(config.limit * 3, config.limit), 50);
    }

    var endpoint = 'https://' + config.shop + '/api/' + config.apiVersion + '/graphql.json';
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
      },
      body: JSON.stringify({
        query: ARTICLES_QUERY,
        variables: { q: buildQuery(blogTitle, tag), n: fetchLimit },
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        if (!json || !json.data || !json.data.articles) return [];
        var nodes = json.data.articles.edges.map(function (edge) {
          return edge.node;
        });
        if (hideWithoutImage) {
          nodes = nodes.filter(hasArticleImage);
        }
        return nodes.slice(0, config.limit);
      });
  }

  function slideHTML(node, blogHandle, config) {
    var url = node.onlineStoreUrl || '/blogs/' + blogHandle + '/' + node.handle;
    var media =
      node.image && node.image.url
        ? '<img class="sbtas-card__image" src="' +
          esc(withWidth(node.image.url, config.imageWidth)) +
          '" loading="lazy" alt="' +
          esc(node.image.altText || node.title) +
          '">'
        : '<span class="sbtas-card__placeholder" aria-hidden="true"></span>';

    return (
      '<div class="swiper-slide"><article class="sbtas-card">' +
      '<a href="' + esc(url) + '" class="sbtas-card__media">' + media + '</a>' +
      '<div class="sbtas-card__body">' +
      (node.title
        ? '<h3 class="sbtas-card__title"><a href="' + esc(url) + '">' + esc(node.title) + '</a></h3>'
        : '') +
      '<a href="' + esc(url) + '" class="sbtas-card__button">' + esc(config.buttonLabel) + '</a>' +
      '</div></article></div>'
    );
  }

  function loadSlider(slider, config) {
    var wrapper = slider.querySelector('[data-sbtas-wrapper]');
    var emptyEl = slider.querySelector('[data-sbtas-empty]');
    if (!wrapper) return Promise.resolve();

    var blogHandle = slider.getAttribute('data-blog-handle');
    var blogTitle = slider.getAttribute('data-blog-title');
    var tag = slider.getAttribute('data-tag');
    var hideWithoutImage = slider.getAttribute('data-hide-without-image') === 'true';

    slider.setAttribute('aria-busy', 'true');

    return fetchArticles(config, blogTitle, tag, hideWithoutImage)
      .then(function (nodes) {
        wrapper.innerHTML = nodes
          .map(function (node) {
            return slideHTML(node, blogHandle, config);
          })
          .join('');
        if (emptyEl) emptyEl.toggleAttribute('hidden', nodes.length > 0);
        slider.removeAttribute('aria-busy');
      })
      .catch(function () {
        slider.removeAttribute('aria-busy');
        if (emptyEl) emptyEl.toggleAttribute('hidden', false);
      });
  }

  function mountTaggedSlider(slider) {
    if (typeof Swiper === 'undefined') return null;

    var el = slider.querySelector('.sbtas-swiper');
    if (!el) return null;

    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return null;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    var scrollbarEl = slider.querySelector('.sbtas-scrollbar');
    var gapMobile = parseNumber(slider.dataset.gapMobile, 12);
    var gapTablet = parseNumber(slider.dataset.gapTablet, 16);
    var gapDesktop = parseNumber(slider.dataset.gapDesktop, 20);
    var perViewMobile = parseNumber(slider.dataset.perViewMobile, 1.2);
    var perViewTablet = parseNumber(slider.dataset.perViewTablet, 2);
    var perViewDesktop = parseNumber(slider.dataset.perViewDesktop, 4);

    return new Swiper(el, {
      slidesPerView: perViewMobile,
      spaceBetween: gapMobile,
      speed: 450,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      observer: true,
      observeParents: true,
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            dragSize: 'auto',
          }
        : undefined,
      breakpoints: {
        769: {
          slidesPerView: perViewTablet,
          spaceBetween: gapTablet,
        },
        1200: {
          slidesPerView: perViewDesktop,
          spaceBetween: gapDesktop,
        },
      },
    });
  }

  function initSlider(slider) {
    if (!slider) return;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var swiper = mountTaggedSlider(slider);
        if (swiper) {
          swiper.slideTo(0, 0);
          swiper.update();
        }
      });
    });
  }

  function activateTab(sectionRoot, tab) {
    var targetId = tab.getAttribute('data-target');
    if (!targetId) return;

    sectionRoot.querySelectorAll('[data-sbtas-tab]').forEach(function (button) {
      var isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    sectionRoot.querySelectorAll('[data-sbtas-panel]').forEach(function (panel) {
      var isActive = panel.id === targetId;
      panel.classList.toggle('is-active', isActive);
      panel.toggleAttribute('hidden', !isActive);
    });

    var activePanel = document.getElementById(targetId);
    if (!activePanel || !sectionRoot.contains(activePanel)) return;

    initSlider(activePanel.querySelector('[data-sbtas-slider]'));
  }

  function mountSection(sectionRoot) {
    var container = sectionRoot.querySelector('.sbtas-container');
    if (!container) return;

    if (container.dataset.sbtasSectionBound !== 'true') {
      container.dataset.sbtasSectionBound = 'true';
      sectionRoot.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-sbtas-tab]');
        if (!tab || !sectionRoot.contains(tab)) return;
        activateTab(sectionRoot, tab);
      });
    }

    var config = getConfig(container);
    if (!config.token || !config.shop) {
      if (window.console) console.warn('[Blog Articles Slider] Missing Storefront API token or shop domain.');
      return;
    }

    container.querySelectorAll('[data-sbtas-slider]').forEach(function (slider) {
      loadSlider(slider, config).then(function () {
        var panel = slider.closest('[data-sbtas-panel]');
        if (panel && panel.classList.contains('is-active')) {
          initSlider(slider);
        }
      });
    });
  }

  function boot(root) {
    getSectionRoots(root).forEach(mountSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!root) return;
    boot(root);
  });
})();
